import React from 'react';
import ViewBatchReceiptButtonProperties from "./ViewBatchReceiptButtonProperties";
import {useI18nContext} from "../../../contexts/I18nContext";
import ArticleIcon from '@mui/icons-material/Article';
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import {Observer} from "mobx-react-lite";
import {useStyles} from "./ViewBatchReceiptButton.style";
import Button from "../../../ui_components/Button/Button";
import ButtonType from "../../../ui_components/Button/ButtonType";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import SidePanel from "../../../ui_components/SidePanel/SidePanel";
import ViewSingleBatchReceipt from './ViewSingleBatchReceipt/ViewSingleBatchReceipt';


const ViewBatchReceiptButton: React.FC<ViewBatchReceiptButtonProperties> = ({
                                                                      onClick = () => {
                                                                      },
                                                                      onSave = () => {
                                                                      },
                                                                      children,
                                                                      showIcon = true,
                                                                      showText = true,
                                                                      disabled,
                                                                      className = '',
                                                                      productOrderIds,
                                                                      single = true,
                                                                      rounded = false,
                                                                      showButton = true,
                                                                      size = ButtonSize.DEFAULT,
                                                                      type = ButtonType.DEFAULT
                                                                  }) => {
    const classes = useStyles(showText);
    const i18n = useI18nContext();
    const [isModalOpen, setIsModalOpen] = React.useState(false);

    const handleOnclick = async () => {
        setIsModalOpen(true);
        onClick();
    }

    const onCloseModal = () => {
        setIsModalOpen(false);
        if (onSave) {
            onSave();
        }
    }

    const text = i18n.translate("INVOICE_SINGULAR");
    const Icon = ArticleIcon;
    const Btn = () => {
        if (rounded) {
            return <RoundedButton
                onClick={handleOnclick}
                className={className}
                disabled={disabled}
                tooltip={!showText ? text : ""}
                text={showText ? text : ""}
                type={type}
                icon={showIcon ? <Icon/> : <></>}
            />
        }
        return <Button
            text={showText ? text : ""}
            className={className}
            tooltip={!showText ? text : ""}
            disabled={disabled}
            size={size}
            onClick={handleOnclick}
            type={type}
            startIcon={showIcon ? <Icon/> : <></>}
        />
    }

    return <Observer>
        {() => (
            <>
                <SidePanel title={`${i18n.translate("INVOICE_SINGULAR")}`}
                           onClose={onCloseModal} open={isModalOpen} className={classes.modal_container}>
                    <div className={classes.view_invoice_container}>
                        <ViewSingleBatchReceipt productOrderIds={productOrderIds}/>
                    </div>
                </SidePanel>
                {showButton && <Btn/>}
                {!showButton && <div onClick={handleOnclick}>{children}</div>}
            </>
        )}
    </Observer>
}

export default ViewBatchReceiptButton;
